<template>
  <div class="page">
    <div class="title">{{model.title}}</div>
    <div v-html="model.content"></div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Panel, Cell, CellGroup, Button, Tag, Icon, Toast, Dialog, Field, Image} from 'vant';
  import moment from 'moment';
  import {getNoticeLog} from '@/api/admin/notice'
  import { badge } from '@/main.js';

  Vue.use(Panel)
      .use(Cell)
      .use(CellGroup)
      .use(Button)
      .use(Tag)
      .use(Icon)
      .use(Toast)
      .use(Dialog)
      .use(Field)
      .use(Image)

  export default {
    name: 'log-detail',
    components:{},
    data () {
      return {
        model: {
          title: null,
          content: null
        }
      }
    },
    methods: {
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getNoticeLog(this.$route.params.id).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model = data.data;
            badge.$emit('badge');
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
    },
    mounted() {
      this.loadData()
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>
.page {
  padding: 16px;
  .title{
    font-size: 16px;
    text-align: center;
    margin-bottom: 16px;
    font-weight: bold;
  }
}
</style>
